import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useCGUFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    hasAcceptedCGU: z.boolean().refine(val => val === true, {
      message: t('formErrors.hasAcceptedCGU'),
    }),
    cguId: z.string().min(1, t('formErrors.required')),
  });
};

export type CGUFormData = z.infer<ReturnType<typeof useCGUFormSchema>>;

export const useCGUForm = (initialData?: Partial<CGUFormData>) => {
  const cguSchema = useCGUFormSchema();

  const form = useForm<CGUFormData>({
    resolver: zodResolver(cguSchema),
    defaultValues: {
      hasAcceptedCGU: initialData?.hasAcceptedCGU || false,
      cguId: initialData?.cguId || '',
    },
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  useEffect(() => {
    form.reset({
      hasAcceptedCGU: initialData?.hasAcceptedCGU || false,
      cguId: initialData?.cguId || '',
    });
  }, [form, initialData]);

  const setCGUId = (cguId: string) => {
    form.setValue('cguId', cguId);
  };

  return {
    form,
    setCGUId,
  };
};
